import { ReactNode } from "react";

import { TenantRole } from "@oneleet/api_client";

import { ArrowUpRightSquareIcon } from "lucide-react";

export const TENANT_ROLES: Record<
  TenantRole,
  {
    accessTitle: string;
    accessDescription: ReactNode;
    isAvailableOption: boolean;
    order: number;
  }
> = {
  [TenantRole.FORMER_EMPLOYEE]: {
    accessTitle: "None",
    accessDescription: "This person no longer has access to your workspace",
    isAvailableOption: false,
    order: 0,
  },
  [TenantRole.EMPLOYEE]: {
    accessTitle: "Portal",
    accessDescription: (
      <span>
        This person only has access to the{" "}
        <a
          className="text-brand-300 inline-flex items-center gap-1"
          href={import.meta.env.VITE_PORTAL_URL}
          target="_blank"
          rel="noreferrer"
        >
          Oneleet Portal
          <ArrowUpRightSquareIcon className="h-4 w-4" />
        </a>{" "}
        to complete assigned tasks
      </span>
    ),
    isAvailableOption: false,
    order: 0,
  },
  [TenantRole.MEMBER]: {
    accessTitle: "Member",
    accessDescription:
      "Members have full viewing but limited edit permissions in your workspace",
    isAvailableOption: true,
    order: 1,
  },
  [TenantRole.AUDITOR]: {
    accessTitle: "Auditor",
    accessDescription:
      "Auditors have read-only access, and cannot see any internal communications between you and the Oneleet team, or access the portal",
    isAvailableOption: true,
    order: 2,
  },
  [TenantRole.ADMIN]: {
    accessTitle: "Admin",
    accessDescription:
      "Admins have full viewing and edit permissions in your workspace",
    isAvailableOption: true,
    order: 3,
  },
};
